export default "__VITE_ASSET__BirdUTxb__"